import { InjectionToken } from '@angular/core';
import { FrLoginInterfaceMapper } from '@shared/lib/models/fr-login-interface-mapper';
import { LoginContextProvider } from '@shared/lib/providers/login-context.provider';

export const LOGIN_INTERFACES = new InjectionToken<FrLoginInterfaceMapper>('sso.login-interfaces');

export const LOGIN_CONTEXTS = new InjectionToken<LoginContextProvider[]>('sso.login-context-providers');
